import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="invites--handle-external-invite"
export default class extends Controller {
  handleExternalInvite() {
    document.getElementById("handle-external-invite").click();
  }
}
